import { memo } from 'react';
import Tooltip from '@mui/material/Tooltip';

export default memo(Tooltip);
